import {
  CreateSubscriptionOverloadDocument,
  CreateSubscriptionOverloadMutation,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import useActiveSubscriptionOverload from './useActiveSubscriptionOverload'

// Using business as default bc if the paid subscription has core enterprise the user won't loose the features
const CORE_BASE_B_PLAN = 'core_b-area_a'
const OVERLOAD_REASON = 'module_trial'

interface CreateSubscriptionParams {
  chargebeeId: string
}

const useCreateTrialModuleSubscription = (companyIds: [number]) => {
  const { activeSubscriptionOverload } = useActiveSubscriptionOverload(companyIds)

  const [mutate] = useMutation(CreateSubscriptionOverloadDocument, {
    extractorFn: (createData: CreateSubscriptionOverloadMutation) =>
      createData.companiesMutations.createModuleTrialCompaniesSubscriptionOverload,
  })

  const createSubscription = (params: CreateSubscriptionParams) => {
    const { chargebeeId } = params

    let addonsUpdated = []
    let expirationDate = new Date()

    if (activeSubscriptionOverload) {
      // If there's an active subscription, we add to the addonsIds the new chargebeeId so users can try as many modules as they want
      const { addonIds, expirationDate: currentExpirationDate } = activeSubscriptionOverload

      // The expirationDate will be the same we set with the first trial so users don't take advantage of infinite trials
      expirationDate = new Date(currentExpirationDate)
      addonsUpdated = Array.from(new Set([...addonIds, chargebeeId]))
    } else {
      // If there's not an active subscription, we just add the new chargebeeId and set the expiration date in 14 days
      addonsUpdated = [chargebeeId]
      expirationDate.setDate(expirationDate.getDate() + 14)
    }

    track(trackingEvents.marketplaceModules.createModuleTrial, {
      addons_in_tiral: addonsUpdated,
      expiration_date: expirationDate.toISOString(),
    })

    return mutate({
      variables: {
        addonIds: addonsUpdated,
        expirationDate: expirationDate.toISOString(),
        overloadReason: OVERLOAD_REASON,
        planId: CORE_BASE_B_PLAN,
      },
    })
  }

  return createSubscription
}

export default useCreateTrialModuleSubscription
